import { Time } from '@angular/common';
import { BaseDto } from '../base.dto';
import { MerchantDto } from '../merchant.dto';
import { GiftCardTypeDto } from './giftCardType.dto';

// NOTE: To prevent circular dependencies the same type is implemented on API where GiftCardType entity is implemented.
export type RestrictionType = 'below' | 'above';

export class GiftCardPromotionDto extends BaseDto {
  startDate?: Date;
  endDate?: Date;
  startTime?: Time;
  endTime?: Time;
  fixedAmount?: number;
  percentageAmount?: number;
  name?: string;
  description?: string;
  merchants: MerchantDto[];
  giftCardTypes: GiftCardTypeDto[];
  onRegistration: boolean;
  onActivation: boolean;
  onTopup: boolean;
  restriction?: RestrictionType;
  restrictionValue?: number;
}
